import { createElement } from "react";
import React from "react";
import { useCtx } from "./Context.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { tap } from "./fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.29.0/Async.js";
import { toastServerError, User } from "./ApiClient.jsx";
import { TrackProgressCard } from "./Track/UserProgress.jsx";
import { SkeletonItem, Skeleton } from "@fluentui/react-components";
import { createObj } from "./fable_modules/fable-library-js.4.29.0/Util.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "./fable_modules/fable-library-js.4.29.0/List.js";

/**
 * `/bruker/<id>/fremdrift` page. Fetches the user once and mounts `TrackProgressCard`.
 * Back navigation is handled by the Desktop breadcrumb (and browser back on Mobile).
 */
export function UserFremdrift(userFremdriftInputProps) {
    let elems, el, el_2;
    const userId = userFremdriftInputProps.userId;
    const patternInput = useCtx();
    const patternInput_1 = reactApi.useState(undefined);
    const userOpt = patternInput_1[0];
    const dependencies = [userId];
    reactApi.useEffect(() => {
        const pr = tap((res) => {
            if (res.tag === 1) {
            }
            else {
                patternInput_1[1](res.fields[0]);
            }
        }, startAsPromise(User.GetUser(userId)));
        void (pr.catch((ex) => {
            toastServerError(patternInput[1], ex);
        }));
    }, dependencies);
    if (userOpt != null) {
        return createElement(TrackProgressCard, userOpt);
    }
    else {
        const el_4 = Skeleton;
        return createElement(el_4, createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 12 + "px ",
        }], (elems = [(el = SkeletonItem, createElement(el, {
            style: {
                height: 80,
            },
            shape: "rectangle",
            animation: "wave",
        })), (el_2 = SkeletonItem, createElement(el_2, {
            style: {
                height: 200,
            },
            shape: "rectangle",
            animation: "wave",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
    }
}

//# sourceMappingURL=UserFremdrift.jsx.map
